import { ChangeEvent } from "react";
import { Option } from "../../../../types/General/Option";

interface IndicatorSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  isLoaded: boolean;
}

export const regionTableSelectFilterData = (
  subSystemOptions: Option[],
  typeOptions: Option[],
  stateOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedFilter: (filterName: string, value: string | null) => void,
  subSystemLoaded: boolean,
  typeLoaded: boolean,
  stateLoaded: boolean,
): IndicatorSelectComponent[] => {
  const handleSelectChange =
    (filterName: string) => (e: ChangeEvent<HTMLSelectElement>) => {
      const selectedId = e.target.value;
      const selectedText = e.target.selectedOptions[0].text;
      setSelectedFilter(filterName, selectedText);
      setFilter(filterName, selectedId);
    };

  return [
    {
      fieldNameObject: "SubSystemId",
      options: subSystemOptions,
      fieldName: "Sub-sistema",
      control: control,
      width: "230px",
      onChange: handleSelectChange("SubSystemId"),
      isLoaded: subSystemLoaded,
    },
    {
      fieldNameObject: "IndicatorTypeId",
      options: typeOptions,
      fieldName: "Tipo de indicador",
      control: control,
      width: "230px",
      onChange: handleSelectChange("IndicatorTypeId"),
      isLoaded: typeLoaded,
    },
    {
      fieldNameObject: "StateId",
      options: stateOptions,
      fieldName: "Estado do indicador",
      control: control,
      width: "230px",
      onChange: handleSelectChange("StateId"),
      isLoaded: stateLoaded,
    },
  ];
};
